import React, { useState } from "react";
import {
    Zap,
    Bell,
    User,
    ChevronDown,
    Menu,
    X,
    Search,
    Wallet as WalletIcon,
} from "lucide-react";
import { ethers } from "ethers";
import { NavLink } from "react-router-dom";
import { useWallet } from "../context/WalletContext";

function PageHeader({ onLogin }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    // const [account, setAccount] = useState(null);
    // const [walletName, setWalletName] = useState(null);
    // const [connected, setConnected] = useState(false);
    // const [provider, setProvider] = useState(null);
    // const [signer, setSigner] = useState(null);
    const { account, walletName, connected, connect } = useWallet();

    // const detectWalletName = (eth) => {
    //     if (eth.isMetaMask) return "MetaMask";
    //     if (eth.isTrust) return "Trust Wallet";
    //     return "Wallet";
    // };

    // const connect = async () => {
    //     const eth = window.ethereum;
    //     if (!eth) {
    //         alert("No wallet detected. Install MetaMask or Trust Wallet, or use their in-app browser.");
    //         return;
    //     }
    //     try {
    //         const prov = new ethers.BrowserProvider(eth);
    //         await prov.send("eth_requestAccounts", []);
    //         const signer_ = await prov.getSigner();
    //         const addr = await signer_.getAddress();
    //
    //         setProvider(prov);
    //         setSigner(signer_);
    //         setAccount(addr);
    //         setWalletName(detectWalletName(eth));
    //         setConnected(true);
    //     } catch (err) {
    //         console.error("Wallet connection failed", err);
    //     }
    // };

    const shortAddr = (a) =>
        a && a.length > 10 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a || "Not connected";

    return (
        <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-gray-200">
            <div className="px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                {/* Brand + Nav */}
                <div className="flex items-center">
                    <div className="flex items-center gap-2">
                        <Zap className="h-8 w-8 text-indigo-600" />
                        <span className="text-xl font-semibold">EnergyChain</span>
                    </div>

                    <nav className="hidden md:ml-8 md:flex md:space-x-6">
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                `px-3 py-2 text-sm font-medium ${
                                    isActive
                                        ? "text-indigo-600 border-b-2 border-indigo-600"
                                        : "text-gray-500 hover:text-gray-900"
                                }`
                            }
                        >
                            Dashboard
                        </NavLink>

                        <NavLink
                            to="/energy-marketplace"
                            className={({ isActive }) =>
                                `px-3 py-2 text-sm font-medium ${
                                    isActive
                                        ? "text-indigo-600 border-b-2 border-indigo-600"
                                        : "text-gray-500 hover:text-gray-900"
                                }`
                            }
                        >
                            Marketplace
                        </NavLink>

                        <NavLink
                            to="/agreement"
                            className={({ isActive }) =>
                                `px-3 py-2 text-sm font-medium ${
                                    isActive
                                        ? "text-indigo-600 border-b-2 border-indigo-600"
                                        : "text-gray-500 hover:text-gray-900"
                                }`
                            }
                        >
                            Agreement
                        </NavLink>
                        
                        {/*<NavLink*/}
                        {/*    to="/device-agreement-registry"*/}
                        {/*    className={({ isActive }) =>*/}
                        {/*        `px-3 py-2 text-sm font-medium ${*/}
                        {/*            isActive*/}
                        {/*                ? "text-indigo-600 border-b-2 border-indigo-600"*/}
                        {/*                : "text-gray-500 hover:text-gray-900"*/}
                        {/*        }`*/}
                        {/*    }*/}
                        {/*>*/}
                        {/*    Registry*/}
                        {/*</NavLink>*/}
                    </nav>
                </div>

                {/* Actions */}
                <div className="flex items-center gap-4">
                    {/* Notifications */}
                    <button className="p-2 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hidden md:flex">
                        <Bell className="h-5 w-5" />
                    </button>

                    {/* User Info */}
                    <div className="hidden md:flex items-center gap-2 bg-gray-100 py-1 px-3 rounded-full">
                        <User className="h-5 w-5 text-gray-600" />
                        <span className="text-sm font-medium">Admin</span>
                        <ChevronDown className="h-4 w-4 text-gray-500" />
                    </div>

                    {/* Wallet Label */}
                    <div className="hidden md:flex items-center text-sm text-gray-500 gap-1 max-w-[220px] truncate">
                        <WalletIcon className="h-4 w-4" />
                        <span className="truncate max-w-[140px]">{shortAddr(account)}</span>
                        <span className="text-gray-400">•</span>
                        <span>{walletName || "-"}</span>
                    </div>

                    {/* Connect Wallet */}
                    <button
                        onClick={connect}
                        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700"
                    >
                        {connected ? "Connected" : "Connect Wallet"}
                    </button>

                    {/* Search */}
                    <a
                        href="#search"
                        className="hidden sm:inline-flex items-center gap-2 px-3 py-2 text-sm rounded-md border border-gray-200 hover:bg-gray-50 text-gray-700"
                        onClick={(e) => {
                            const el = document.getElementById("global-search");
                            if (el) {
                                e.preventDefault();
                                el.focus();
                            }
                        }}
                    >
                        <Search className="h-4 w-4" />
                        Search
                    </a>

                    {/* Login */}
                    <a
                        href="/login"
                        onClick={(e) => {
                            if (onLogin) {
                                e.preventDefault();
                                onLogin();
                            }
                        }}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
                    >
                        Login
                    </a>

                    {/* Mobile Menu Toggle */}
                    <button
                        className="md:hidden p-2"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {/* Mobile menu */}
            {mobileMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-200 py-2">
                    <NavLink
                        to="/dashboard"
                        className={({ isActive }) =>
                            `block px-4 py-2 text-base font-medium ${
                                isActive ? "text-indigo-600" : "text-gray-500 hover:text-gray-900"
                            }`
                        }
                    >
                        Dashboard
                    </NavLink>

                    <NavLink
                        to="/energy-marketplace"
                        className={({ isActive }) =>
                            `block px-4 py-2 text-base font-medium ${
                                isActive ? "text-indigo-600" : "text-gray-500 hover:text-gray-900"
                            }`
                        }
                    >
                        Marketplace
                    </NavLink>

                    <NavLink
                        to="/agreement"
                        className={({ isActive }) =>
                            `block px-4 py-2 text-base font-medium ${
                                isActive ? "text-indigo-600" : "text-gray-500 hover:text-gray-900"
                            }`
                        }
                    >
                        Agreement
                    </NavLink>
                    
                    {/*<NavLink*/}
                    {/*    to="/device-agreement-registry"*/}
                    {/*    className={({ isActive }) =>*/}
                    {/*        `block px-4 py-2 text-base font-medium ${*/}
                    {/*            isActive ? "text-indigo-600" : "text-gray-500 hover:text-gray-900"*/}
                    {/*        }`*/}
                    {/*    }*/}
                    {/*>*/}
                    {/*    Registry*/}
                    {/*</NavLink>*/}


                </div>
            )}
        </header>
    );
}

export default PageHeader;
